import { render, staticRenderFns } from "./ConsultantNav.vue?vue&type=template&id=92b5d484&"
import script from "./ConsultantNav.vue?vue&type=script&lang=ts&"
export * from "./ConsultantNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports